/* eslint-disable */
export default {
  title: 'Historial',
} as const;

// @key: @#@"title"@#@ @source: @#@"History"@#@
